import { render, staticRenderFns } from "./BRadio.vue?vue&type=template&id=016f8536&"
import script from "./BRadio.vue?vue&type=script&lang=js&"
export * from "./BRadio.vue?vue&type=script&lang=js&"
import style0 from "./BRadio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports